import React from 'react';
import { withRouter } from 'react-router-dom';
import { addDays, isSameDay, e4Format, e4Formats, isPast } from 'helpers/dates';
import { Box, Help, Modal, SystemText } from 'e4shared';
import { taskStatuses, taskStatus } from 'helpers/profile';
import TaskIcon from 'views/user/task/components/taskIcon';

export const Day = ({ history, close, tasks, date, show }) => {
    const goToTask = task => {
        if (task.appraisal_Id) {
            history.push(`/develop/reviews/${task.appraisal_Id}?oid=${task.date_Completed ? '' : task.id}`);
        } else {
            history.push(`/objectives/${task.profile_Id}/objective/${task.id}`);
        }
    };

    if (!tasks) return null;

    const taskBadgeColour = task => {
        if (task.date_Completed) return '';

        return isPast(task.due)
            ? 'label table-label label-danger'
            : isPast(addDays(task.due, -14))
            ? 'label table-label label-warning'
            : '';
    };

    const footer = (
        <div>
            <button className="btn" onClick={() => close()}>
                {SystemText('Tasks/TaskCalendar/Day/Close')}
            </button>
        </div>
    );

    const tasksFiltered = tasks.filter(
        t => (isSameDay(t.due, date) && !t.date_Completed) || (isSameDay(t.date_Completed, date) && t.date_Completed)
    );

    return (
        <Modal
            show={show}
            title={SystemText('Tasks/TaskCalendar/Day/Title', e4Format(date, e4Formats.long))}
            close={close}
            footer={footer}
        >
            <Box>
                <div className="table-responsive">
                    <table className="table table-hover mb10">
                        <thead>
                            <tr>
                                <th>{SystemText('Tasks/TaskCalendar/Day/Table/Objective')}</th>
                                <th>{SystemText('Tasks/TaskCalendar/Day/Table/Status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tasksFiltered.length === 0 && (
                                <tr>
                                    <td colSpan="4" className="td-no-results">
                                        {SystemText('Tasks/TaskCalendar/Day/NoResults')}
                                    </td>
                                </tr>
                            )}
                            {tasksFiltered.map(task => {
                                const status = taskStatus(task);
                                return (
                                    <tr key={task.id} onClick={() => goToTask(task)} className="pointer">
                                        <td>
                                            {task.name}
                                            <TaskIcon icons={task.icons} />
                                            {task.description && <Help id={`row_${task.id}`}>{task.description}</Help>}
                                            <div className="mt5">
                                                <div className={`summary-due ${taskBadgeColour(task)}`}>
                                                    {SystemText('Tasks/TaskCalendar/Day/Due')}: {e4Format(task.due)}
                                                </div>
                                            </div>
                                        </td>
                                        {status === taskStatuses.Completed && (
                                            <td>
                                                <span className="label label-success">
                                                    {SystemText('Tasks/TaskCalendar/Day/Completed')}
                                                </span>
                                            </td>
                                        )}
                                        {status === taskStatuses.AwaitingApproval && (
                                            <td>
                                                <span className="label label-warning">
                                                    {SystemText('Tasks/TaskCalendar/Day/Awaiting')}
                                                </span>
                                            </td>
                                        )}
                                        {status === taskStatuses.Overdue && (
                                            <td>
                                                <span className="label label-danger">
                                                    {SystemText('Tasks/TaskCalendar/Day/Overdue')}
                                                </span>
                                            </td>
                                        )}
                                        {status === taskStatuses.Outstanding && (
                                            <td>
                                                <span className="label label-default">
                                                    {SystemText('Tasks/TaskCalendar/Day/Outstanding')}
                                                </span>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Box>
        </Modal>
    );
};

export default withRouter(Day);
